import { IUpdateAlertUserModel } from '../../interfaces/Report/IReport';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useCloseAlertMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (alertUserModel: IUpdateAlertUserModel) => {
            const response = await zoneApiClient.closeAlert(alertUserModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                throw new Error(response.errorMessage ?? 'Failed to Close Alert');
            }

            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
};
